// extracted by mini-css-extract-plugin
export var filterButton = "_s2-1";
export var filtersContainer = "_s2-0";